module.exports = "mutation DenyNotification($id: ID!) {\n  denyNotification(id: $id) {\n    success\n  }\n}\n"